export default __webpack_public_path__ + "static/consulenza-strategica-per-aziende-astrorei-700bb318522512ee88b3c904f7bf87ef.jpg";